export default "__VITE_ASSET__Ds$GoTGq__"